// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconLogoApple = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M16.526 0a5.37 5.37 0 01-1.228 3.847 4.52 4.52 0 01-3.568 1.687 5.1 5.1 0 011.261-3.705A5.46 5.46 0 0116.526 0m2.493 10.141a5.45 5.45 0 00-.71 2.622 5.27 5.27 0 003.217 4.849 12.1 12.1 0 01-1.673 3.408c-.986 1.474-2.02 2.915-3.66 2.942-.78.018-1.307-.207-1.856-.44-.572-.244-1.169-.498-2.102-.498-.99 0-1.613.262-2.214.515-.52.218-1.022.43-1.73.46-1.563.057-2.757-1.574-3.779-3.035-2.041-2.983-3.631-8.407-1.5-12.097a5.86 5.86 0 014.93-3.007c.886-.018 1.736.324 2.482.623.57.23 1.078.433 1.495.433.366 0 .86-.196 1.437-.425.908-.36 2.019-.801 3.15-.682a5.59 5.59 0 014.4 2.378 5.45 5.45 0 00-1.887 1.954" />
  );
export default SvgIconLogoApple;
